import type LegacyModal from '@orientaction/components/ModalCardPref';
import { ComponentProps } from 'react';
import DetailModal, { ContentList, Html } from '.';
import { useDetailModalStyles } from './DetailModal.styles';

const PreferenceDetailModal = (props: ComponentProps<typeof LegacyModal>) => {
  const { open, onCancel, label, img, color, value, title, youAre, text1, text2, list1, list2 } =
    props;
  const classes = useDetailModalStyles();
  return (
    <DetailModal
      open={open}
      onCancel={onCancel}
      label={label}
      img={img}
      color={color}
      value={value}
      isPercent={true}
      introduction={
        <>
          <h3>{title}</h3>
          <p>
            Vous êtes <strong>{youAre}</strong>
          </p>
        </>
      }>
      <section className={`${classes.section} ${classes.columns}`}>
        <div>
          <h3>Votre style général</h3>
          <Html text={text1} />
        </div>
        <div>
          <h3>Vos relations avec les autres</h3>
          <Html text={text2} />
        </div>
      </section>
      <section className={`${classes.panel} ${classes.columns}`} style={{ backgroundColor: color }}>
        <div>
          <h2>Ce qui vous stimule</h2>
          <ContentList items={list1} />
        </div>
        <div>
          <h2>Ce qui vous épuise</h2>
          <ContentList items={list2} />
        </div>
      </section>
    </DetailModal>
  );
};

export default PreferenceDetailModal;
